module.exports = __webpack_public_path__ + "static/media/gift-cards.53cd25b2.jpg";